(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5755],{

/***/ 94157:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/choose.7ee3671a.svg","height":683,"width":683});

/***/ }),

/***/ 37507:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hot-cup.d3dc6dca.svg","height":464,"width":464});

/***/ }),

/***/ 93755:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/location.9955f1a7.svg","height":512,"width":512});

/***/ }),

/***/ 57922:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/blurred-background.01a1e933.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBQACAwAAAAAAAAAAAAABAAIDBBEFExQhUf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECESL/2gAMAwEAAhEDEQA/AJLOSvWfMgN2y2SO3MDJ2nHjBgLRg9fUREKLwWT/2Q==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 48443:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/commercial.0713c918.jpg","height":370,"width":700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgEFAAAAAAAAAAAAAAABAwACERQhIjFx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8ApbvdqXKDmCtTQjFztx68iIhKY//Z","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 22086:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/map.8d8580ab.jpg","height":864,"width":1674,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAXEAEBAQEAAAAAAAAAAAAAAAAAAQMR/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AK5he2gA/9k=","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 22396:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/affirm-dark.99e1094d.png","height":36,"width":90,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAALVBMVEUAMDAAGyoPr/sAFSIADxgAFyQPsv8LerMABAgAIjUAGioSqvUAChIISm0HRmb/Qar+AAAAD3RSTlMCYjhzL5pPgD13hRt+e0i270SIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgYGDgZmNiY2JgYWTl5WPhYGdg5WJkZubkYQcABgYAhr+eOjQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 16379:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/video-thumbnail.62c3259c.png","height":572,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEUAAAC6yMmqvMGJpLF7hoWAi5KSpa24y9NDPzqTkoF+i5I5NDQAAACHlp9ISEOXo5+errZ1lqGcpZSXtcR8l6NZV1Vbd4GqrKxTU0zl/f8Ne/DgAAAADXRSTlMh/v7+7+3v7/D27TUeBrGDUQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUeJwFwYUBACAMA7DiuuH2/6MkMJWIasxwo031HGC3OLJpQJfQSw+AX3yZffopfwHag6ISHAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 5836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ city_HybridElectricLandingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/static/images/landing/blurred-background.jpg
var blurred_background = __webpack_require__(57922);
// EXTERNAL MODULE: ./src/static/images/landing/commercial.jpg
var commercial = __webpack_require__(48443);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(2277);
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(13311);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/static/images/icon/landing/choose.svg
var choose = __webpack_require__(94157);
// EXTERNAL MODULE: ./src/static/images/icon/landing/hot-cup.svg
var hot_cup = __webpack_require__(37507);
// EXTERNAL MODULE: ./src/static/images/icon/landing/location.svg
var landing_location = __webpack_require__(93755);
// EXTERNAL MODULE: ./src/static/images/landing/map.jpg
var map = __webpack_require__(22086);
;// CONCATENATED MODULE: ./src/static/images/landing/pattern.svg
/* harmony default export */ var pattern = ({"src":"/_next/static/media/pattern.c9f5564a.svg","height":1,"width":2});
;// CONCATENATED MODULE: ./src/static/images/landing/phone-animation.svg
/* harmony default export */ var phone_animation = ({"src":"/_next/static/media/phone-animation.7842a773.svg","height":460,"width":720});
// EXTERNAL MODULE: ./src/static/images/logos/affirm-dark.png
var affirm_dark = __webpack_require__(22396);
// EXTERNAL MODULE: ./src/static/images/video-thumbnail.png
var video_thumbnail = __webpack_require__(16379);
;// CONCATENATED MODULE: ./src/components/city/HybridElectricLandingPage.jsx


















var VideoModalCommercial = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(5406), __webpack_require__.e(5732)]).then(__webpack_require__.bind(__webpack_require__, 75732)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75732)
            ];
        }
    }
});
var Reviews = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1874), __webpack_require__.e(9503)]).then(__webpack_require__.bind(__webpack_require__, 61874)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61874)
            ];
        }
    }
});
var ContactModal = dynamic_default()(__webpack_require__.e(/* import() */ 7684).then(__webpack_require__.bind(__webpack_require__, 97684)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97684)
            ];
        }
    }
});
var VideoModal = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(5406), __webpack_require__.e(6566)]).then(__webpack_require__.bind(__webpack_require__, 76566)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76566)
            ];
        }
    }
});
function HybridElectricLandingPage(param) {
    var phoneNumber = param.phoneNumber, geolocation = param.geolocation, myHref = param.myHref, asVar = param.asVar, googleNumber = param.googleNumber, CMSData = param.CMSData;
    var ref = (0,react.useState)(false), contactModalOpen = ref[0], setcontactModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), videoModalOpen = ref1[0], setvideoModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), videoModalCommercial = ref2[0], setvideoModalCommercialOpen = ref2[1];
    var sections = get_default()(CMSData, "sections");
    var coverText = find_default()(sections, {
        section_id: "cover_text"
    }) && find_default()(sections, {
        section_id: "cover_text"
    }).content;
    var descriptionText = find_default()(sections, {
        section_id: "description"
    }) && find_default()(sections, {
        section_id: "description"
    }).content;
    var features = find_default()(sections, {
        section_id: "features"
    }) && find_default()(sections, {
        section_id: "features"
    }).features;
    var tagline = find_default()(sections, {
        section_id: "features"
    }) && find_default()(sections, {
        section_id: "features"
    }).subtitle;
    var howTheProcessWorks = find_default()(sections, {
        section_id: "how_it_works"
    });
    (0,react.useEffect)(function() {
        // FIXME: document not accessible instantly on load (V.T. 11.2.2022)
        if (true) {
            if (document.querySelectorAll("h2 strong").length > 0) {
                var addressDescription = document.querySelectorAll("h2 strong");
                addressDescription[0].innerHTML = geolocation && geolocation.formatted_address ? geolocation.formatted_address : "Your Area";
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "landing hybrid-electric",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactModal, {
                toPhoneNumber: phoneNumber,
                open: contactModalOpen,
                onCloseModal: function() {
                    return setcontactModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal, {
                open: videoModalOpen,
                onCloseModal: function() {
                    return setvideoModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModalCommercial, {
                open: videoModalCommercial,
                onCloseModal: function() {
                    return setvideoModalCommercialOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cover-container",
                style: {
                    background: "#FFFFFF url(".concat(map/* default.src */.Z.src, ") bottom left")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "cover",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "item-element",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "text-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                    children: [
                                                        coverText || "Hybrid and Electric Battery Replacement in",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "Your City")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "search-form",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "action-buttons",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: myHref,
                                                                            as: asVar,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                className: "btn book",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                        className: "fas fa-car-battery"
                                                                                    }),
                                                                                    " Schedule Online",
                                                                                    " "
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            className: "btn text-us",
                                                                            href: "tel:".concat(googleNumber),
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                    className: "fas fa-phone"
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "Get Help Now"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "gradient-border mt-3"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                                                                type: "minimal"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "image-container",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: phone_animation.src
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "disclaimers",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "disclaimer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-check-circle"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                        children: [
                                                                            "In Route ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            " Communication"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "disclaimer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "inner",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-check-circle"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                        children: [
                                                                            "Uber Like ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            " Experience"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "services"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bottom-container",
                style: {
                    background: "#FFFFFF url(".concat(pattern.src, ") center center")
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "bottom",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "items-container",
                                    children: [
                                        features && features.map(function(item, i) {
                                            var icons = [
                                                "fas fa-shipping-fast",
                                                "fas fa-calendar-check",
                                                "fas fa-wrench"
                                            ];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "img",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: icons[i],
                                                            "aria-hidden": "true"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: item.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: item.content
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.title);
                                        }),
                                        !features && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "img",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-shipping-fast",
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    children: "FAST DELIVERY"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Most orders are 90 minutes or Less"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "img",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-calendar-check",
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    className: "",
                                                                    children: "Make an Appointment"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "",
                                                                    children: "Not an Emergency, schedule an appointment at your around your busy schedule."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "item",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "img",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-wrench",
                                                                "aria-hidden": "true"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "text",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                    className: "",
                                                                    children: "PROFESSIONAL INSTALLATION!"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "",
                                                                    children: [
                                                                        "We Test Electrical, Install New Battery, Test Again and Recycle old Battery ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            children: "(Computer Resets too)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                tagline && (0,utils/* markdownify */.gI)(tagline),
                                !tagline && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "We are the ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "largest Battery Marketplace"
                                        }),
                                        " in North America. Over",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "10,000"
                                        }),
                                        " products, ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "250,000"
                                        }),
                                        " locations, and",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "1,000,000"
                                        }),
                                        " needs served."
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "how-it-works"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-with-sample-report align-middle",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inner",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-8 align-middle",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: howTheProcessWorks ? howTheProcessWorks.title : "How the Process Works"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: howTheProcessWorks ? howTheProcessWorks.subtitle : "This is the easiest to use Battery platform in the world today, combining the best about DoorDash, Uber, and making the installation of batteries transparent and cheaper for you. From Prices to Delivery, we keep you informed and no hidden fees. If you have any questions we are always available. Please watch the 90 second video for more info."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image",
                                        onClick: function() {
                                            return setvideoModalOpen(true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                width: "400px",
                                                height: "229px",
                                                src: video_thumbnail/* default */.Z,
                                                alt: "Car Battery Installation Video",
                                                className: "lazyload"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "steps",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row",
                            children: howTheProcessWorks ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: howTheProcessWorks.features.map(function(item, index) {
                                    var images = [
                                        landing_location/* default.src */.Z.src,
                                        choose/* default.src */.Z.src,
                                        hot_cup/* default.src */.Z.src
                                    ];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: myHref,
                                            as: asVar,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "start-here",
                                                        children: "Start Here"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: images[index],
                                                        alt: "",
                                                        className: "lazyload"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                        children: [
                                                            "Step ",
                                                            index + 1
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: item.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: item.content
                                                    })
                                                ]
                                            })
                                        })
                                    }, index);
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: myHref,
                                            as: asVar,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "start-here",
                                                        children: "Start Here"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: landing_location/* default.src */.Z.src,
                                                        alt: "",
                                                        className: "lazyload"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: "Step 1"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Provide your Information"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "We will provide an immediate price quote based on your vehicle model and location."
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: myHref,
                                            as: asVar,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: choose/* default.src */.Z.src,
                                                        alt: "",
                                                        className: "lazyload"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: "Step 2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Select your Service Option"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "We offer ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Pickup, Delivery and Installation"
                                                            }),
                                                            " options."
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: myHref,
                                            as: asVar,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item no-affirm-disclaimer-border",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: hot_cup/* default.src */.Z.src,
                                                        alt: "",
                                                        className: "lazyload"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: "Step 3"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                        children: "Place your order and we do the rest."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "If you choose Delivery we’ll come to you. If you choose a Store our Technicians will be waiting for you."
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dynamic-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                    children: descriptionText ? (0,utils/* markdownify */.gI)(descriptionText) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Your car battery seems to run a little rough, with multiple starts needed or stalling throughout your drive. Or, you find your car won’t start at all — and you’re miles away from home."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Making an appointment for car battery replacement services seems like the most logical solution. But, when you’re stranded, you need service now — no waiting, no calling for a friend to pick you up, and no coordinating with a towing company to get your vehicle to the closest auto shop."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "For the",
                                                    " ",
                                                    "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "your"),
                                                    " ",
                                                    "area, 1-800-Battery provides fast mobile car battery replacement and install services. We build off our status as the largest batter marketplace in North America to offer just-in-time and precise car battery installation. When you need us, we’re there, accompanied by our wealth of knowledge."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                children: [
                                                    "Car Battery Delivery and Installation in",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        children: "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "Your Area")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Yes, we offer car batteries for sale among our more than 10,000 products. But, 1-800-Battery is more than just a retailer; we provide our customers with white-glove car and truck battery installation, too. What can we offer you, whether you need car battery replacement now or in the near future?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "We're cheaper than any dealership"
                                                            }),
                                                            ", and quicker, too. Instead of expensive towing and lengthy appointment times, we come to you with the correct battery for your vehicle. And, rather than tacking on extra fees, we roll the cost of installation into our single, transparent price."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "We’re home of the JumpStart Guarantee:"
                                                            }),
                                                            " Also unlike dealerships, we won’t pressure you to replace your car battery.Instead, unless testing shows it’s needed, we keep your existing battery in your car."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "We also offer a Correct Battery Guarantee:"
                                                            }),
                                                            " We carry",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://1800battery.com/category/vehicle-batteries-car-or-truck/",
                                                                children: "car and truck batteries"
                                                            }),
                                                            " ",
                                                            "by make and model. We’ll be prepared, no matter the notice, with the corresponding solution."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "Get service when you need it:"
                                                            }),
                                                            " Book an appointment online for immediate delivery and service, or schedule an appointment for a later date. For same-day work, we’ll drive out to your location — home, work parking lot or the side of the road in the Miami area — with the right car or truck battery from our expansive product selection."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "We prioritize service"
                                                            }),
                                                            " Along with rapid response, our professionals provide full car battery replacement service.We test the existing battery, can install a new unit, and then test it again to ensure everything’s working.We then recycle the old battery."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Don’t wait around or go for weeks without a car.If you're in",
                                                    " ",
                                                    "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "need"),
                                                    " ",
                                                    "and your car battery clearly needs replacement, get it done quickly and accurately with 1-800-Battery. Contact us today to set up an appointment."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "landing-checklist in-sidebar mt-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item odd",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Book Online for Immediate Delivery or Make Appointment"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Installation Included in Price - No Hidden Charges!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item odd",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Our JumpStart Guarantee!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Professional Technicans with Real Time Tracking!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Buy now, pay over time with",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: affirm_dark/* default.src */.Z.src,
                                                                alt: "Car Battery Installation Video",
                                                                className: "lazyload"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "search-form",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "action-buttons sidebar",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "inner",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: myHref,
                                                            as: asVar,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: "btn book",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                        className: "fas fa-shopping-cart"
                                                                    }),
                                                                    " Book Online",
                                                                    " "
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "btn text-us",
                                                            href: "tel:tel:+18002288379",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-phone",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Get Help Now"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-md-3 reviews-sidebar",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                                                    type: "minimal"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "commercial",
                    style: {
                        background: "url(".concat(blurred_background/* default.src */.Z.src, ") center center")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner",
                        onClick: function() {
                            return setvideoModalCommercialOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tv",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-play-circle"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: commercial/* default.src */.Z.src,
                                        alt: "commercial"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Watch our commercial"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                    type: "static"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container text-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "search-form",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "action-buttons",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inner justify-content-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: myHref,
                                        as: asVar,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "btn book",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-car-battery"
                                                }),
                                                " Schedule Online",
                                                " "
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "btn text-us",
                                        href: "tel:".concat(googleNumber),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-phone"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Get Help Now"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var city_HybridElectricLandingPage = (HybridElectricLandingPage);


/***/ }),

/***/ 72411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ city_VehicleLandingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/static/images/icon/landing/choose.svg
var choose = __webpack_require__(94157);
// EXTERNAL MODULE: ./src/static/images/icon/landing/hot-cup.svg
var hot_cup = __webpack_require__(37507);
// EXTERNAL MODULE: ./src/static/images/icon/landing/location.svg
var landing_location = __webpack_require__(93755);
// EXTERNAL MODULE: ./src/static/images/landing/blurred-background.jpg
var blurred_background = __webpack_require__(57922);
// EXTERNAL MODULE: ./src/static/images/landing/commercial.jpg
var commercial = __webpack_require__(48443);
;// CONCATENATED MODULE: ./src/static/images/landing/cover-mobile.jpg
/* harmony default export */ var cover_mobile = ({"src":"/_next/static/media/cover-mobile.d490ad22.jpg","height":1333,"width":1166,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAcDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAACAgMAAwAAAAAAAAAAAAACAwABBQYxIWGh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQT/xAAZEQADAAMAAAAAAAAAAAAAAAAAAQIDESH/2gAMAwEAAhEDEQA/AKe+bbkMVkFoBCRACtgPYN+xoe+e38iIl2KIc9lDto//2Q==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/static/images/landing/cover-optimized-shade.jpg
/* harmony default export */ var cover_optimized_shade = ({"src":"/_next/static/media/cover-optimized-shade.dd094819.jpg","height":1333,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAEAAgIDAQAAAAAAAAAAAAABAAMCEQQGE/D/xAAUAQEAAAAAAAAAAAAAAAAAAAAC/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQACITH/2gAMAwEAAhEDEQA/AK7u1byMB9bKiq7By80HPTvSo/MRERZORFRNn//Z","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./src/static/images/landing/map.jpg
var map = __webpack_require__(22086);
// EXTERNAL MODULE: ./src/static/images/logos/affirm-dark.png
var affirm_dark = __webpack_require__(22396);
// EXTERNAL MODULE: ./src/static/images/video-thumbnail.png
var video_thumbnail = __webpack_require__(16379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/city/sections/WhyFeatures.jsx
var WhyFeatures = __webpack_require__(19103);
;// CONCATENATED MODULE: ./src/components/city/VehicleLandingPage.js

















var Reviews = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(1874), __webpack_require__.e(9503)]).then(__webpack_require__.bind(__webpack_require__, 61874)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61874)
            ];
        }
    }
});
var ContactModal = dynamic_default()(__webpack_require__.e(/* import() */ 7684).then(__webpack_require__.bind(__webpack_require__, 97684)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97684)
            ];
        }
    }
});
var VideoModal = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(5406), __webpack_require__.e(6566)]).then(__webpack_require__.bind(__webpack_require__, 76566)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76566)
            ];
        }
    }
});
var VideoModalCommercial = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(5406), __webpack_require__.e(5732)]).then(__webpack_require__.bind(__webpack_require__, 75732)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75732)
            ];
        }
    }
});
function VehicleLandingPage(param) {
    var phoneNumber = param.phoneNumber, geolocation = param.geolocation, myHref = param.myHref, asVar = param.asVar, googleNumber = param.googleNumber, CMSData = param.CMSData, vehicleDescription = param.vehicleDescription;
    var ref = (0,react.useState)(false), contactModalOpen = ref[0], setcontactModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), videoModalOpen = ref1[0], setvideoModalOpen = ref1[1];
    var ref2 = (0,react.useState)(false), videoModalCommercial = ref2[0], setvideoModalCommercialOpen = ref2[1];
    var ref3 = (0,react.useState)(0), size = ref3[0], setSize = ref3[1];
    (0,react.useEffect)(function() {
        // FIXME: window not accessible instantly on load (V.T. 11.2.2022)
        if (true) {
            setSize(window.innerWidth);
        }
    }, []);
    if (myHref.substring(0, 1) != "/") {
        myHref = "/" + myHref;
    }
    asVar = myHref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "landing city",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactModal, {
                toPhoneNumber: phoneNumber,
                open: contactModalOpen,
                onCloseModal: function() {
                    return setcontactModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal, {
                open: videoModalOpen,
                onCloseModal: function() {
                    return setvideoModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModalCommercial, {
                open: videoModalCommercial,
                onCloseModal: function() {
                    return setvideoModalCommercialOpen(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-[url('/images/tech-mobile.jpg')] lg:bg-none",
                style: {
                    backgroundSize: "100% auto",
                    backgroundPosition: "top center",
                    backgroundRepeat: "no-repeat"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container mx-auto sm:pt-10 !mb-3 md:!mb-5 !pt-[200px] lg:!pt-[100px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white shadow-sm rounded-md relative overflow-hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:bg-[url(/images/tech.webp)]",
                            style: {
                                backgroundSize: "700px auto",
                                backgroundPosition: "top right",
                                backgroundRepeat: "no-repeat"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "!p-5 py-10 md:!p-10 md:!py-15 mx-w-[80%] lg:max-w-[50%]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-3xl md:text-5xl tracking-tight text-[#0F2435] w-full !leading-[2.5rem] md:!leading-[3.5rem]",
                                                children: [
                                                    "Mobile Car & Truck Battery Replacement Service in",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-semibold",
                                                        children: "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "Your City")
                                                    }),
                                                    vehicleDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            " ",
                                                            "for your ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "font-semibold ",
                                                                children: "".concat(vehicleDescription)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "md:inline-block !mt-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center gap-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: myHref,
                                                        as: asVar,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "w-[300px] max-w-[100%] bg-[#4c942f] mx-auto flex flex-1 items-center justify-center rounded-sm !py-4 !px-3 md:px-10 text-base text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 sm:full bg-brand-primary hover:bg-brand-primary/90 text-base font-semibold",
                                                            children: [
                                                                "SCHEDULE ONLINE ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "far fa-arrow-right ml-2"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "!mt-4",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                                                    type: "minimal"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-[2px] bg-gradient-to-r from-slate-300 to-transparent"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "!p-5 md:!p-10",
                                    id: "services",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyFeatures/* default */.Z, {})
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "!mt-4",
                style: {
                    backgroundImage: "url(/images/happy-clients.jpg)",
                    backgroundSize: "700px auto",
                    backgroundPosition: "top right",
                    backgroundRepeat: "no-repeat"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container bg-white/80 lg:bg-transparent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                        href: myHref,
                        type: "static-v2"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-with-sample-report align-middle",
                id: "how-it-works",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "inner",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-8 align-middle",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "How the Process Works"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "This is the easiest to use Battery platform in the world today, combining the best about DoorDash, Uber, and making the installation of batteries transparent and cheaper for you. From Prices to Delivery, we keep you informed and no hidden fees. If you have any questions we are always available. Please watch the 90 second video for more info."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "image mt-3",
                                        onClick: function() {
                                            return setvideoModalOpen(true);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                width: "400px",
                                                height: "229px",
                                                src: video_thumbnail/* default */.Z,
                                                alt: "Car Battery Installation Video",
                                                className: "lazyload"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "steps",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: myHref,
                                        as: asVar,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "start-here",
                                                    children: "Start Here"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: landing_location/* default.src */.Z.src,
                                                    alt: "",
                                                    className: "lazyload"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Step 1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "Provide your Information"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "We will provide an immediate price quote based on your vehicle model and location."
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: myHref,
                                        as: asVar,
                                        prefetch: false,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "item",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: choose/* default.src */.Z.src,
                                                    alt: "",
                                                    className: "lazyload"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Step 2"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "Select your Service Option"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "We offer ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Pickup, Delivery and Installation"
                                                        }),
                                                        " options."
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: myHref,
                                        as: asVar,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "item no-affirm-disclaimer-border",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: hot_cup/* default.src */.Z.src,
                                                    alt: "",
                                                    className: "lazyload"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    children: "Step 3"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "Place your order and we do the rest."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "If you choose Delivery we’ll come to you. If you choose a Store our Technicians will be waiting for you."
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "dynamic-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Your car battery seems to run a little rough, with multiple starts needed or stalling throughout your drive. Or, you find your car won’t start at all — and you’re miles away from home."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Making an appointment for car battery replacement services seems like the most logical solution. But, when you’re stranded, you need service now — no waiting, no calling for a friend to pick you up, and no coordinating with a towing company to get your vehicle to the closest auto shop."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "For the",
                                                " ",
                                                "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "your"),
                                                " ",
                                                "area, 1-800-Battery provides fast mobile car battery replacement and install services. We build off our status as the largest batter marketplace in North America to offer just-in-time and precise car battery installation. When you need us, we’re there, accompanied by our wealth of knowledge."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                            children: [
                                                "Car Battery Delivery and Installation in",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "Your Area")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Yes, we offer car batteries for sale among our more than 10,000 products. But, 1-800-Battery is more than just a retailer; we provide our customers with white-glove car and truck battery installation, too. What can we offer you, whether you need car battery replacement now or in the near future?"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "We're cheaper than any dealership"
                                                        }),
                                                        ", and quicker, too. Instead of expensive towing and lengthy appointment times, we come to you with the correct battery for your vehicle. And, rather than tacking on extra fees, we roll the cost of installation into our single, transparent price."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "We’re home of the JumpStart Guarantee:"
                                                        }),
                                                        " Also unlike dealerships, we won’t pressure you to replace your car battery.Instead, unless testing shows it’s needed, we keep your existing battery in your car."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "We also offer a Correct Battery Guarantee:"
                                                        }),
                                                        " We carry",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://1800battery.com/category/vehicle-batteries-car-or-truck/",
                                                            children: "car and truck batteries"
                                                        }),
                                                        " ",
                                                        "by make and model. We’ll be prepared, no matter the notice, with the corresponding solution."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "Get service when you need it:"
                                                        }),
                                                        " Book an appointment online for immediate delivery and service, or schedule an appointment for a later date. For same-day work, we’ll drive out to your location — home, work parking lot or the side of the road in",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "".concat(geolocation && geolocation.formatted_address ? "the " + geolocation.formatted_address : "your city")
                                                        }),
                                                        " ",
                                                        "area - with the right car or truck battery from our expansive product selection."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "We prioritize service"
                                                        }),
                                                        " Along with rapid response, our professionals provide full car battery replacement service.We test the existing battery, can install a new unit, and then test it again to ensure everything’s working.We then recycle the old battery."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Don’t wait around or go for weeks without a car.If you're in",
                                                " ",
                                                "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "need"),
                                                " ",
                                                "and your car battery clearly needs replacement, get it done quickly and accurately with 1-800-Battery. Contact us today to set up an appointment."
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "landing-checklist in-sidebar mt-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item odd",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Book Online for Immediate Delivery or Make Appointment"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Installation Included in Price - No Hidden Charges!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item odd",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Our JumpStart Guarantee!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Professional Technicans with Real Time Tracking!"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "item ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-check"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Buy now, pay over time with",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: affirm_dark/* default.src */.Z.src,
                                                                alt: "Car Battery Installation Video",
                                                                className: "lazyload"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "search-form",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "action-buttons sidebar",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "inner",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: myHref,
                                                        as: asVar,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "btn book",
                                                            children: [
                                                                "GET STARTED ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "far fa-arrow-right"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mt-md-3 reviews-sidebar",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews, {
                                                    href: myHref,
                                                    type: "minimal"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "commercial",
                    style: {
                        background: "url(".concat(blurred_background/* default.src */.Z.src, ") center center")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner",
                        onClick: function() {
                            return setvideoModalCommercialOpen(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tv",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "icon-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-play-circle"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: commercial/* default.src */.Z.src,
                                        alt: "commercial"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Watch our commercial"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var city_VehicleLandingPage = (VehicleLandingPage);


/***/ }),

/***/ 19103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var features = [
    {
        name: "Professional installation included in price",
        description: "No Hidden Charges!",
        iconSrc: "/images/why-us/professional-installation.svg"
    },
    {
        name: "Fitment guaranteed",
        description: "Buy with confidence knowing that your new car battery will fit perfectly",
        iconSrc: "/images/why-us/fitment.svg"
    },
    {
        name: "We come to you",
        description: "Whether you're on the road or relaxing at home, we bring our services directly to you, ensuring hassle-free battery replacements.",
        iconSrc: "/images/why-us/we-come-to-you.svg"
    },
    {
        name: "Geolocation for fast and efficient service",
        description: "Through the geolocation-based operations, we automatically locate the nearest shop and assign an available technician to handle your battery replacement.",
        iconSrc: "/images/why-us/geolocation.svg"
    },
    {
        name: "Make an appointment",
        description: "You have the flexibility to choose the appointment time that aligns with your schedule and the location that is most convenient for you.",
        iconSrc: "/images/why-us/make-an-appoitment.svg"
    },
    {
        name: "Track your order in real time",
        description: "Track the progress of your order, including the real-time location of our technician and an accurate ETA.",
        iconSrc: "/images/why-us/track-your-delivery.svg"
    },
    {
        name: "Buy now, pay over time",
        description: "Make your purchase now and spread out the payments over a period of time. Powered by Affirm.",
        iconSrc: "/images/why-us/affirm.svg"
    },
    {
        name: "Customer approved",
        description: "Our customers say Excellent based on 4000+ reviews",
        iconSrc: "/images/why-us/customer-approved.svg"
    }, 
];
var WhyFeatures = function(param) {
    var title = param.title, hideDescription = param.hideDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "mt-2 text-2xl font-semibold tracking-tight text-gray-800 sm:text-4xl",
                children: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-2xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-2 text-2xl font-semibold tracking-tight text-gray-800 sm:text-3xl",
                        children: "We are the largest Battery Marketplace in North America. Over 10,000 products, 250,000 locations, and 1,000,000 needs served."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl !mt-4",
                        children: "From Cars to Coin Cells we have everything available."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto mt-16 sm:mt-20 lg:mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                    className: "grid grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16",
                    children: features.map(function(feature) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative pl-16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dt", {
                                    className: "text-base font-semibold leading-7 text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                src: feature.iconSrc,
                                                width: 64,
                                                height: 64,
                                                alt: feature.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-xl",
                                            children: feature.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                    className: "mt-2 text-base leading-7 text-gray-700",
                                    children: feature.description
                                })
                            ]
                        }, feature.name);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhyFeatures);


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ utils_link; },
  "xf": function() { return /* reexport */ CategoryUrl; },
  "AK": function() { return /* reexport */ ClassNames; },
  "vn": function() { return /* reexport */ HtmlToReact; },
  "gI": function() { return /* reexport */ Markdownify; },
  "o2": function() { return /* reexport */ PostUrl; },
  "JF": function() { return /* reexport */ SafePrefix; }
});

// UNUSED EXPORTS: withPrefix

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/utils/classNames.js


// TODO: why do we need this? (V.T. 20.12.2021)
function ClassNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _classNames;
    return (_classNames = (classnames_default())).call.apply(_classNames, [
        this
    ].concat((0,_to_consumable_array/* default */.Z)(args))) || null;
}

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/utils/htmlToReact.js


// TODO: why do we need this? (V.T. 20.12.2021)
function HtmlToReact(html) {
    if (!html) {
        return null;
    }
    return (0,lib/* default */.ZP)(html, {
        transform: function(node) {
            if (node.type === "script") {
                if (!isEmpty_default()(node.children)) {
                    return "";
                } else {
                    return "";
                }
            }
        }
    });
}

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(87441);
;// CONCATENATED MODULE: ./src/utils/markdownify.js


function Markdownify(markdown) {
    if (!markdown) {
        return null;
    }
    return HtmlToReact(marked_esm/* marked.parse */.TU.parse(markdown));
}

// EXTERNAL MODULE: ./node_modules/lodash/startsWith.js
var startsWith = __webpack_require__(10240);
var startsWith_default = /*#__PURE__*/__webpack_require__.n(startsWith);
;// CONCATENATED MODULE: ./src/utils/safePrefix.js

var withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function SafePrefix(url) {
    if (startsWith_default()(url, "#") || startsWith_default()(url, "http")) {
        return url;
    }
    return withPrefix(url);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/link.js






var Link = function(_param) {
    var children = _param.children, href = _param.href, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    // Pass Any internal link to Next.js Link, for anything else, use <a> tag
    var internal = /^\/(?!\/)/.test(href);
    // For root page, use index.js, for rest use [...slug].js
    var page = href === "/" ? "/" : "/[...slug]";
    var slug = href.split("/");
    if (slug.length > 2) {
        if (slug[1] == "category") {
            page = "/category/[categoryid]?categoryid=".concat(slug[2]);
        }
        if (slug[1] == "product") {
            page = "/product/[productid]?productid=".concat(slug[2]);
        }
    }
    if (internal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: page,
            as: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: href
    }, other), {
        children: children
    }));
};
/* harmony default export */ var utils_link = (Link);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/trim.js
var trim = __webpack_require__(92742);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./src/utils/postUrl.js


var postUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function PostUrl(post) {
    var slug = trim_default()(get_default()(post, "slug"), "/");
    return postUrl_withPrefix("/blog/".concat(slug));
}

;// CONCATENATED MODULE: ./src/utils/categoryUrl.js


var categoryUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
// TODO: Generalize function and reuse (V.T. 31.1.2022)
function CategoryUrl(category) {
    var slug = trim_default()(get_default()(category, "slug"), "/");
    return categoryUrl_withPrefix("/blog/category/".concat(slug));
}

// EXTERNAL MODULE: ./src/utils/withPrefix.js
var utils_withPrefix = __webpack_require__(15629);
;// CONCATENATED MODULE: ./src/utils/index.js










/***/ }),

/***/ 28669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ sanity; }
/* harmony export */ });
/* harmony import */ var _sanity_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59729);
/* harmony import */ var _sanity_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_sanity_client__WEBPACK_IMPORTED_MODULE_0__);

var isDev = "production" === "development";
var sanity = _sanity_client__WEBPACK_IMPORTED_MODULE_0___default()({
    accessToken: "skULzhIetYBSuxUYoBQmoxRO7LLzvtvs0cI6hNPVe7V7u4mxNzFwznp4GVDpzEW6RYfR0EkYcU9eR8SLgZ75v0lXAnJ3u4eE7GGyYTj5MzVka3HzXMddoAALSVVUHiGh1fFAGi4D7pgKGi2L34CalwMBc4Fg61KRGJBDo560VvNyjHe6izwp",
    projectId: "r1sgfpjk",
    dataset: "production",
    isPreview: isDev,
    watch: false,
    useCdn: false,
    apiVersion: "2021-08-31"
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (sanity)));


/***/ }),

/***/ 15629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WithPrefix; }
/* harmony export */ });
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98392);
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__);

function WithPrefix(url) {
    var basePath = "";
    return basePath + "/" + lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default()(url, "/");
}


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);